import styled from 'styled-components';

const Date = styled.div`
  font-size: 10px;
  margin-top: 4px;
  width: 100%;
  text-align: right;
`;

export default Date;
